export default class PaymentModalService {
/**
 * @param {string} quantityOrder - The quantity of the order
 * @param {string} subscriptionType - The type of the subscription
 * @param {string} coupon - The coupon code
 * @param {string} currency - The currency of the order
 * @param {string} cardBtnActiion - The action for the card button
 * @param {string} paypalBtnAction - The action for the paypal button
 * @param {boolean} isAllowedForPayPal - Whether the currency is supported by PayPal
 */
  static setChoosePaymentMethodActions({
    quantityOrder,
    subscriptionType,
    coupon,
    currency,
    cardBtnActiion,
    paypalBtnAction,
    isAllowedForPayPal = true,
  }) {
    const modal = document.querySelector("#choosePaymentMethod");
    const creditCardBtn = modal.querySelector(".btn-credit-card");
    const paypalBtn = modal.querySelector(".btn-paypal");
    const paypalWarning = modal.querySelector(".paypal-currency-warning");

    creditCardBtn.setAttribute(
      "data-action",
      `click->payment--choose-payment-method-modal#${cardBtnActiion}`
    );

    if (isAllowedForPayPal) {
      paypalBtn.removeAttribute("disabled");
      paypalBtn.setAttribute(
        "data-action",
        `click->payment--choose-payment-method-modal#${paypalBtnAction}`
      );
      paypalWarning?.classList.add("d-none");
    } else {
      paypalBtn.setAttribute("disabled", true);
      paypalBtn.removeAttribute("data-action");
      paypalWarning?.classList.remove("d-none");
    }

    currency && modal.setAttribute(
      "data-payment--choose-payment-method-modal-currency-value",
      currency
    );
    coupon &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-coupon-value",
        coupon
      );
    quantityOrder &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-quantity-order-value",
        quantityOrder
      );
    subscriptionType &&
      modal.setAttribute(
        "data-payment--choose-payment-method-modal-subscription-type-value",
        subscriptionType
      );
  }
}
